import _ from 'lodash';
import Vue from 'vue';
import Router from 'vue-router';
import Account from '@/components/Account';
import Article from '@/components/Article';
import Articles from '@/components/Articles';
import ApproveMember from '@/components/ApproveMember';
import Channels from '@/components/Channels';
import Collections from '@/components/Collections';
import Events from '@/components/Events';
import EventRegistrations from '@/components/EventRegistrations';
import EventForm from '@/components/EventForm';
import Login from '@/components/Login';
import Ministries from '@/components/Ministries';
import Media from '@/components/Media';
import Pages from '@/components/Pages';
import PasswordReset from '@/components/PasswordReset';
import Speakers from '@/components/Speakers';
import Users from '@/components/Users';

import store from '@/store/index';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

Vue.use(Router);

const checkAccess = (field, next) => {
  const auth = store.state.users.authenticated;
  if (auth.id && auth.access[field]) {
    next();
  } else {
    next({ name: 'login' });
  }
};

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: () => {
        const authenticated = store.getters[getters.GET_AUTHENTICATED_USER];
        const pages = store.getters[getters.GET_APP_PAGES];
        const filtered = _.filter(pages, page => authenticated.access[page]);
        if (filtered.length > 0) {
          return filtered[0];
        }
        return 'home';
      },
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      beforeEnter(to, from, next) {
        return checkAccess('account', next);
      },
    },
    {
      path: '/pages',
      name: 'pages',
      component: Pages,
    },
    {
      path: '/articles',
      name: 'articles',
      component: Articles,
      beforeEnter(to, from, next) {
        return checkAccess('articles', next);
      },
    },
    {
      path: '/articles/:id',
      name: 'article',
      component: Article,
      props: route => ({
        id: route.params.id,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('articles', next);
      },
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      props: route => ({
        tab: parseInt(route.query.tab, 10),
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('events', next);
      },
    },
    {
      path: '/events/:id/registrations',
      name: 'event_registrations',
      component: EventRegistrations,
      props: route => ({
        id: route.params.id,
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('events', next);
      },
    },
    {
      path: '/events/:id/form',
      name: 'event_form',
      component: EventForm,
      props: route => ({
        id: route.params.id,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('events', next);
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/password_reset',
      name: 'passwordReset',
      component: PasswordReset,
      props: route => ({
        ses: route.query.ses,
      }),
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      props: route => ({
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('users', next);
      },
    },
    {
      path: '/media',
      name: 'media',
      component: Media,
      props: route => ({
        tab: route.query.tab,
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('media', next);
      },
    },
    {
      path: '/channels',
      name: 'channels',
      component: Channels,
      props: route => ({
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('media', next);
      },
    },
    {
      path: '/collections',
      name: 'collections',
      component: Collections,
      props: route => ({
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('media', next);
      },
    },
    {
      path: '/speakers',
      name: 'speakers',
      component: Speakers,
      props: route => ({
        page: route.query.page ? parseInt(route.query.page, 10) : 1,
      }),
      beforeEnter(to, from, next) {
        return checkAccess('media', next);
      },
    },
    {
      path: '/ministries',
      name: 'ministries',
      component: Ministries,
      props: route => ({
        tab: parseInt(route.query.tab, 10),
      }),
      beforeEnter(to, from, next) {
        return checkAccess('church', next);
      },
    },
    {
      path: '/members/:id',
      name: 'approveMember',
      component: ApproveMember,
      props: route => ({
        id: route.params.id,
        action: route.query.action,
      }),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    'approveMember',
    'login',
    'passwordReset',
  ];
  if (publicPages.includes(to.name)) {
    next();
  } else if (store.getters[getters.GET_IS_AUTHENTICATED]) {
    store.dispatch(actions.DO_SET_TOKEN)
      .then(() => {
        if (store.state.users.authenticated.id === undefined) {
          store.dispatch(actions.DO_GET_AUTHENTICATED_USER)
            .then(() => {
              next();
            });
        } else {
          next();
        }
      });
  } else {
    store.dispatch(actions.DO_LOGOUT)
      .then(() => {
        next({ name: 'login' });
      });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js